import { render } from "./PatientChat.vue?vue&type=template&id=59f5d8aa"
import script from "./PatientChat.vue?vue&type=script&lang=js"
export * from "./PatientChat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__